export default "/images/579e9a2c8d7047aed165fa69d5e18687.avif";